<template>
  <div id="app">
    <!--路由视口-->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <navbar v-if="!$route.meta.navbarHide"></navbar>
  </div>
</template>

<script>
import navbar from "./components/common/navbar"; //详情

export default {
  name: "App",
  components: {
    navbar,
  },
  mounted() {
    this.setMap();
  },
  methods: {
    //设置百度地图
    setMap() {
      var script = document.createElement("script");
      script.type = "text/javascript";
      script.src = "//api.map.baidu.com/api?type=webgl&v=1.0&ak=J1FjlxXJDXdZJUDvk6lHxrxPbof0y50W&callback=init";
      document.body.appendChild(script);
    },
  },
};
</script>

<style lang="scss" scoped></style>
